import React from 'react';
import { isEmpty, cloneDeep } from 'lodash';

import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import PreviewIcon from '@material-ui/icons/RemoveRedEyeOutlined';

import { moveAndPushDown } from '../../common/collection';

import ACButton from '../../atoms/ACButton';
import Stop from './Stop';
import SetStop from './SetStop';
import ACDialog from '../../atoms/ACDialog';

import styles from './Stops.module.scss';


export default class Stops extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      highlight: -1,
      isModalOpen: false,
      stop: {},
      isACDialogOpen: false,
      errors: [],
    };
  }

  onOpenModal = () => {
    this.setState({ isModalOpen: true });
  };

  onCloseModal = () => {
    this.setState({ isModalOpen: false });
  };

  onSelectStop = (stop) => {
    const { getChallengesBySparkIdFunc, getCluesBySparkIdFunc } = this.props;
    const { spark = {} } = stop;
    const { id } = spark;
    this.setState({ stop });
    if (!isEmpty(id)) {
      getChallengesBySparkIdFunc(id);
      getCluesBySparkIdFunc(id);
    }
    this.onOpenModal();
  };

  onClickACDialogOK = () => {
    this.setState({ isACDialogOpen: false, errors: [] });
  };

  onClickACDialogClose = () => {
    this.setState({ isACDialogOpen: false, errors: [] });
  };

  onChangeStop = (name, value) => {
    const { stop = {} } = cloneDeep(this.state);
    stop[name] = value;
    this.setState({ stop });
  };

  onSaveStop = () => {
    if (this.checkForErrors()) {
      this.setState({ isACDialogOpen: true });
      return;
    }
    const { stop = {} } = cloneDeep(this.state);
    const { stops = [], onSaveStopsFunc } = cloneDeep(this.props);

    const { index = -1 } = stop;
    const parsedIndex = parseInt(index.toString());
    if (isEmpty(stop)) return null;

    if (parsedIndex >= 0) {
      stops[parsedIndex] = stop;
    } else {
      stops.push(stop);
    }

    onSaveStopsFunc(stops);
    this.onCloseModal();
  };

  onDeleteStop = (index) => {
    const { stops = [], onSaveStopsFunc } = cloneDeep(this.props);

    const parsedIndex = parseInt(index.toString());
    stops.splice(parsedIndex, 1);

    onSaveStopsFunc(stops);
    this.onCloseModal();
  };

  checkForErrors() {
    const { errors = [], stop } = cloneDeep(this.state);
    const { spark, challenge } = stop;

    if (isEmpty(spark)) {
      errors.push('Please select a connection spark');
    }
    if (isEmpty(challenge)) {
      errors.push('Please select a challenge');
    }

    this.setState({ errors });
    if (!isEmpty(errors)) return true;

    return false;
  }

  onAddStop = () => {
    const { getChallengesBySparkIdFunc, getCluesBySparkIdFunc } = this.props;
    const stop = { index: -1 };
    this.setState({ stop });
    getChallengesBySparkIdFunc('-1');
    getCluesBySparkIdFunc('-1');
    this.onOpenModal();
  };

  onSelect = (name, selectedOption) => {
    const { stop } = cloneDeep(this.state);
    const { object = {} } = selectedOption;
    stop[name] = cloneDeep(object);
    this.setState({ stop });
    if (name === 'spark') this.props.onSelectSparkFunc(object);
  };

  onSelectClue = (clue) => {
    const { stop } = cloneDeep(this.state);
    stop.clue = clue;
    this.setState({ stop });
  };

  highlightDestination = (highlightThisIndex) => {
    this.setState({
      highlight: highlightThisIndex,
    });
  };

  onSwapComplete = (from, to) => {
    const { stops, onSaveStopsFunc } = this.props;

    const fromInt = parseInt(from.toString());
    const toInt = parseInt(to.toString());
    if (fromInt >= 0 && toInt >= 0 && fromInt !== toInt) {
        onSaveStopsFunc(moveAndPushDown(stops, fromInt, toInt));
    }
    this.setState({ highlight: -1 });
  };

  renderStops() {
    const { stops = [] } = this.props;
    const { highlight = -1 } = cloneDeep(this.state);

    if (isEmpty(stops)) return <div />;

    return (
      <div>
        {stops.map((stop, index) => {
          stop.index = index;
          return (
            <Stop
              key={`stop-${index}`}
              onSwapFunc={this.onSwapComplete}
              highlight={highlight}
              highlightDestinationFunc={this.highlightDestination}
              stop={cloneDeep(stop)}
              onClickStopFunc={this.onSelectStop}
            />
          );
        })}
      </div>
    );
  }

  render() {
    const { isModalOpen = false, stop = {}, isACDialogOpen, errors } = cloneDeep(this.state);
    const { sparks = [], challenges = [], clues = [], onInputChangeSparkFunc, onClickPreview } = this.props;

    return (
      <div className={styles.root}>
        <div className={styles.title}>
          <div
            style={{
              marginTop: 'auto',
              marginBottom: 'auto',
            }}
          >
            Available Stops
          </div>
          <div className={styles.previewIcon}>
            <PreviewIcon onClick={onClickPreview} />
          </div>
          <ACButton
            text={'Add'}
            icon={<AddCircleOutlineIcon />}
            iconLast={true}
            onClickFunc={this.onAddStop}
          />
        </div>
        {this.renderStops()}
        <SetStop
          stop={stop}
          sparks={cloneDeep(sparks)}
          challenges={challenges}
          clues={clues}
          isModalOpen={isModalOpen}
          onCloseFunc={this.onCloseModal}
          onSelectFunc={this.onSelect}
          onSelectClueFunc={this.onSelectClue}
          onChangeStopFunc={this.onChangeStop}
          onSaveStopFunc={this.onSaveStop}
          onDeleteStopFunc={this.onDeleteStop}
          onInputChangeSparkFunc={onInputChangeSparkFunc}
        />
        <ACDialog
          isOpen={isACDialogOpen}
          heading="Error"
          body={errors}
          okButtonLabel="OK"
          onClickOkFunc={this.onClickACDialogOK}
          onClickACDialogClose={this.onClickACDialogClose}
        />
      </div>
    );
  }
}
